export default __webpack_public_path__ + "hand-finger-pointing-down.png";